import Vue from 'vue'
import Vuex from 'vuex'
import {
  GetInfo,sign,threelogin,getThreeInfo,getUserInfo
} from "@/api/home";
Vue.use(Vuex);

function persists(store) {
  const local = localStorage.getItem('VUEX:STATE')
  if (local) {
    store.replaceState(JSON.parse(local))
  }
  store.subscribe((mutation, state) => {
    localStorage.setItem('VUEX:STATE', JSON.stringify(state))
  })
}

export default new Vuex.Store({
  plugins: [
    persists
  ],
  state: {
    token: '',
    id: '',
    info:{},//比赛info
    userinfo:{}
  },
  getters: {
    token: state => state.token,
    competitionId: state => state.competitionId,
    info: state => state.info,
    userinfo: state => state.userinfo,
  },
  mutations: {
    SETCOMPETITIONID: (state, id) => {
      state.competitionId = id
    },
    SETINFO:(state,data)=>{
      state.info=data;
    },
    SETTOKEN:(state,data)=>{
      state.token=data;
    },
    USERINFO:(state,data)=>{
      state.userinfo=data;
    }
  },
  actions: {
    // 获取比赛信息
    GetInfo({
      commit
    }) {
      return new Promise((resolve, reject) => {
        GetInfo().then(({data}) => {
          commit('SETCOMPETITIONID', data.id)
          commit('SETINFO', data)
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    Login({
      commit
    },data) {
      return new Promise((resolve, reject) => {
        sign(data).then(({data}) => {
          if(data){
            commit('SETTOKEN', data.token)
            commit('USERINFO', data)
            resolve(data)
          }else{
            reject('注册失败')
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    threeLogin({
      commit
    },data) {
      return new Promise((resolve, reject) => {
        getThreeInfo(data).then(({data}) => {
          let userinfo=data?data.user_info:null;
          if(!userinfo){
            reject('未获取到第三方userinfo')
            return
          }
          threelogin({
            "gender": userinfo.sex,
            "mailbox": userinfo.email,
            "mobile":1606596256,
            "name":1606596256,
            "username": 1606596256
          }).then((data)=>{
            if(data.success){
              let data=data.data;
              commit('SETTOKEN', data.token.token)
              commit('USERINFO', data.token)
              resolve(data)
            }else{
              reject('已经注册')
            }
          }).catch(error => {
            reject(error)
          })
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
})